import types from './RequestStoreDisplayType';

export default class RequestStoreDisplayTitle {
    static [types.CARD] = 'Карточный';
    static [types.TABLE] = 'Табличный';
}
